/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.createc_bridge = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/PuenteMujer.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_BRIDGE);
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_BRIDGE_TOOLTIP);
  },
};

Blockly.Blocks.createc_ship = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Barco.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_SHIP);
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_SHIP_TOOLTIP);
  },
};

Blockly.Blocks.createc_logic_compare_bridge = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    // String 'Boolean', no el constructor: en v13 el constructor Boolean no funciona como check.
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_COMPARE_BRIDGE);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COMPARE_BRIDGE_CLOSED, 'PuenteCerrado'],
        [Blockly.Msg.LANG_COMPARE_BRIDGE_OPEN, 'PuenteAbierto'],
      ]), 'STATE')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

// Sin label entre el sensor y el dropdown a propósito (a diferencia de _bridge): así se ve en prod.
Blockly.Blocks.createc_logic_compare_ship = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    // String 'Boolean', no el constructor: en v13 el constructor Boolean no funciona como check.
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COMPARE_SHIP_WAITING, 'BarcoEsperando'],
        [Blockly.Msg.LANG_COMPARE_SHIP_PASSED, 'BarcoCruzo'],
      ]), 'STATE')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

// El valor del dropdown es la llamada C++ completa, no un enum: se preserva del legacy porque el
// generador la emite tal cual.
Blockly.Blocks.createc_open_puente_mujer = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/PuenteMujer.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_OPEN_PUENTE_MUJER_ON, 'AbrirPuente()'],
        [Blockly.Msg.LANG_OPEN_PUENTE_MUJER_OFF, 'CerrarPuente()'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_OPEN_PUENTE_MUJER).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_OPEN_PUENTE_MUJER_TOOLTIP);
  },
};

Blockly.Blocks.createc_puente_mujer = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/PuenteMujer.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_PUENTE_MUJER).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PUENTE_MUJER_TOOLTIP);
  },
};

Blockly.Blocks.createc_puente_mujer_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/PuenteMujer.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_PUENTE_MUJER_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PUENTE_MUJER_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_luces_dique3 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Dique.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_LUCES_DIQUE3).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUCES_DIQUE3_TOOLTIP);
  },
};

Blockly.Blocks.createc_luces_dique3_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Dique.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LUCES_DIQUE3_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUCES_DIQUE3_OFF_TOOLTIP);
  },
};

Blockly.Blocks.createc_luminaria_zona1 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/LuzCalle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LUMINARIA_ZONA1).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LUMINARIA_ZONA1_TOOLTIP);
  },
};

Blockly.Blocks.createc_senda_peatonal = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/CrucePeatonal.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL2)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_SENDA_PEATONAL).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SENDA_PEATONAL_TOOLTIP);
  },
};

Blockly.Blocks.createc_senda_peatonal_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/CrucePeatonal.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_SENDA_PEATONAL_OFF);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SENDA_PEATONAL_OFF_TOOLTIP);
  },
};
